import { render } from "./DashBoard.vue?vue&type=template&id=1f1bc456&scoped=true"
import script from "./DashBoard.vue?vue&type=script&lang=js"
export * from "./DashBoard.vue?vue&type=script&lang=js"

import "./DashBoard.vue?vue&type=style&index=0&id=1f1bc456&scoped=true&lang=css"

import exportComponent from "/var/www/html/garbage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1bc456"]])

export default __exports__